import { type IColumn, Icon, Typography } from 'shared/ui'
import { type TableStore } from 'shared/ui/TableNew'
import { type TagsRow } from 'entities/Tags/model/TagsRow'
import styles from './styles.module.scss'

type IColumnsProps = {
  tableStore: TableStore<TagsRow>
}

export const columns = ({ tableStore }: IColumnsProps): IColumn<TagsRow>[] => [
  {
    field: 'label',
    name: 'Name',
    width: '46.8%',
    isSortable: true,
    renderHeaderCell: (column) => {
      const isSortActive = column.isSortable && column.field === tableStore.sortBy

      return (
        <div className={styles.headerName}>
          Name
          {isSortActive && (
            <Icon
              icon={tableStore.sortOrder === 'asc' ? 'arrowUp' : 'arrowDown'}
              color='var(--gray-100)'
            />
          )}
        </div>
      )
    },
    renderRowCell: (row) => {
      return (
        <Typography ellipsis tag='div' variant={'body-md-regular'} ariaLabel='tagsName'>
          {row.name}
        </Typography>
      )
    },
  },
  {
    field: 'contacts_count',
    name: 'Tagged contacts',
    isSortable: true,
    renderRowCell: (row) => row.count,
  },
]
